module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/gate/gate.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/gate/gate.png
// module id = 480
// module chunks = 0